module.exports = {
  apiHost: "https://api.somerford.sensoreal.app",
  assetsHost: "https://assets.somerford.sensoreal.app",
  brandName: "Somerford",
  header: {
    text: { en: "Your Somerford Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#50337d",
    textColor: "#fff",
    font: "avenir",
  },
  contact: {
    website: "https://somerford.avid.com.au/",
    address: "21 Laker Boulevard, Clyde North",
    phone: "131 878",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "https://www.facebook.com/avjenningsbyavid/",
  },
  footerLogo: "",
};
